import gql from 'graphql-tag'

export const RENOMEAR_ITEM = gql`
  mutation RenomearItemMutation($idItemBiblioteca: ID!, $novoNome: String!) {
    renomearItemBiblioteca(
      idItemBiblioteca: $idItemBiblioteca
      novoNome: $novoNome
    ) {
      id
      nome
      pastaPai {
        id
      }
    }
  }
`
